var map = {
	"./bh-ico.svg": 790,
	"./bonus-ico.svg": 791,
	"./deposit-ico.svg": 792,
	"./edit-icon.svg": 793,
	"./fb-ico.svg": 794,
	"./instant-rebate-ico.svg": 795,
	"./mall-ico.svg": 796,
	"./msg-ico.svg": 797,
	"./pi-ico.svg": 798,
	"./rf-ico.svg": 799,
	"./rh-ico.svg": 800,
	"./th-ico.svg": 801,
	"./vip-ico.svg": 802,
	"./withdrawal-ico.svg": 803,
	"./wl-ico.svg": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2084;